import { render } from "./TalentCard.vue?vue&type=template&id=454b620c&ts=true"
import script from "./TalentCard.vue?vue&type=script&lang=ts"
export * from "./TalentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__